import EventEmitter from 'eventemitter3';
import playerMethods from '../constants/playerMethods';
import debug from '../../debugger';

const {
  on,
  off,
  preload,
  init,
  load,
  play,
  seek,
  pause,
  stop,
  unload,
  destroy,
  setVolume,
  getVolume,
  toggleMute,
  setTitle,
  getTimes,
  requestInstreamAds,
} = playerMethods;

export default class Player extends EventEmitter {
  constructor(playerName) {
    super();
    this.name = playerName;
  }

  [on]() {
    throw new Error(on + ' must be defined on Player instance');
  }

  [off]() {
    throw new Error(off + ' must be defined on Player instance');
  }

  [preload]() {
    debug.log(preload + ' not defined for Player instance');
  }

  [init]() {
    debug.log(init + ' not defined for Player instance');
  }

  [load]() {
    throw new Error(load + ' must be defined on Player instance');
  }

  [play]() {
    throw new Error(play + ' must be defined on Player instance');
  }

  [seek]() {
    debug.log(seek + ' not defined for Player instance');
  }

  [pause]() {
    throw new Error(pause + ' must be defined on Player instance');
  }

  [stop]() {
    throw new Error(stop + ' must be defined on Player instance');
  }

  [unload]() {
    throw new Error(unload + ' must be defined on Player instance');
  }

  [destroy]() {
    throw new Error(destroy + ' must be defined on Player instance');
  }

  [setVolume]() {
    throw new Error(setVolume + ' must be defined on Player instance');
  }

  [getVolume]() {
    throw new Error(getVolume + ' must be defined on Player instance');
  }

  [toggleMute]() {
    throw new Error(toggleMute + ' must be defined on Player instance');
  }

  [setTitle]() {
    throw new Error(setTitle + ' must be defined on Player instance');
  }

  [getTimes]() {
    throw new Error(getTimes + ' must be defined on Player instance');
  }

  [requestInstreamAds]() {
    debug.log(requestInstreamAds + ' not defined for Player instance');
  }
}
